import type { Mission } from '../missions.ts'

export const usace: Mission = {
  id: "usace",
  name: "U.S. Army Corps of Engineers",
  short: "USACE",
  call: "Engineering",
  kind: "subagency",
  parent: "army",
  url: "https://www.usace.army.mil/",
  established: 1775,
  palette: {
    primary: "#de1e2e",
    secondary: "#1b1b1b",
    accent: "#1b1b1b",
  },
  colorSource: {
    kind: "site",
    url: "https://www.usace.army.mil/",
  },
  motif: "building",
  mission: {
    text: "Deliver vital engineering solutions, in collaboration with our partners, to secure our Nation, energize our economy, and reduce disaster risk.",
    url: "https://www.usace.army.mil/About/Mission-and-Vision/",
  },
  fact: {
    text: "The Army established the Corps of Engineers as a separate, permanent branch on March 16, 1802, and gave the engineers responsibility for founding and operating the U.S. Military Academy at West Point.",
    url: "https://www.usace.army.mil/About/History/Brief-History-of-the-Corps/Introduction/",
  },
  seal: {
    file: "public/seals/usace.svg",
    source: "https://commons.wikimedia.org/wiki/File:United_States_Army_Corps_of_Engineers_logo.svg",
  },
  identifier: {
    about: "https://www.usace.army.mil/About/",
    accessibility: "https://dodcio.defense.gov/DoDSection508/Std_Stmt.aspx",
    foia: "https://www.usace.army.mil/Resources/FOIA/",
    noFear: "https://prhome.defense.gov/nofear",
    oig: "https://www.usace.army.mil/Who-We-Are/Engineer-Inspector-General/",
    performance: "https://www.performance.gov/agencies/dod",
    privacy: "https://www.usace.army.mil/PrivacyandSecurity.aspx",
  },
  media: {
    photos: [
      {
        file: "/media/usace-bonneville.jpg",
        small: "/media/usace-bonneville-sm.jpg",
        alt: "Bonneville Lock and Dam spanning the Columbia River below forested mountains, with the spillway, powerhouses and navigation lock seen from above.",
        title: "Bonneville Dam, wide-angle view downstream, Columbia River Gorge, August 8, 2013",
        creator: "Bonneville Power Administration",
        source: "https://commons.wikimedia.org/wiki/File:Bonneville_Dam_-_wide-angle_view_downstream_(11956069354).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usace-chicago.jpg",
        small: "/media/usace-chicago-sm.jpg",
        alt: "Aerial view of the Chicago Harbor Lock, its long concrete walls and lock chamber reaching out from the city shoreline into the green water of Lake Michigan.",
        title: "Chicago Harbor Lock, aerial view looking west northwest, October 30, 2020",
        creator: "Steve Fischer, U.S. Army Corps of Engineers",
        source: "https://commons.wikimedia.org/wiki/File:Chicago_Harbor_Lock_Aerial_Photo.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
